export default function () {
    return [
        {text: 'morning', value: 'morning'},
        {text: 'noon', value: 'noon'},
        {text: 'night', value: 'night'},
        {text: 'every 6hrs', value: 'every 6hrs '},
        {text: 'every 8hrs', value: 'every 8hrs '},
        {text: 'every 12hrs', value: 'every 12hrs'},
        {text: 'every 24hrs', value: 'every 24hrs'}
    ];
}
